import { useRouteMatch } from 'react-router-dom';
import { ROUTER_ENTITY_TO_ROUTE_PATH_MAP } from '../../../../constants';

type WeatherStationParams = {
  stationId?: string;
};

export const useSelectedWeatherStationId = (): number | undefined => {
  // Using `useRouteMatch()` instead of `useParams()` since we're not always inside the Weather Station <Router>
  const match = useRouteMatch<WeatherStationParams>(
    ROUTER_ENTITY_TO_ROUTE_PATH_MAP.weatherStation,
  );
  const stationIdStr = match?.params.stationId;

  return stationIdStr ? parseInt(stationIdStr, 10) : undefined;
};
